export default 'user-upload'
